import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['tab', 'panel']

  get className () {
    return this.element.dataset.classname
  }

  connect () {
    this.filterOk = this.element.querySelector('[data-filter="ok"]')
    this.filterNg = this.element.querySelector('[data-filter="ng"]')
    this.applyFilter()
  }

  switchTab (e) {
    const targetTab = e.currentTarget
    const index = this.tabTargets.indexOf(targetTab)
    const hiddenClass = `${this.className}::hidden`
    const activeClass = `${this.className}::active`

    this.tabTargets.forEach(tab => tab.classList.remove(activeClass))
    this.panelTargets.forEach(panel => panel.classList.add(hiddenClass))

    targetTab.classList.add(activeClass)
    this.panelTargets[index].classList.remove(hiddenClass)

    this.applyFilter()
  }

  toggleFilter () {
    this.applyFilter()
  }

  applyFilter () {
    if (!this.filterOk || !this.filterNg) return

    const showOk = this.filterOk.checked
    const showNg = this.filterNg.checked
    const hiddenClass = `${this.className}::hidden`

    this.panelTargets.forEach(panel => {
      if (panel.classList.contains(hiddenClass)) return

      const items = panel.querySelectorAll('[data-rate]')
      const groups = panel.querySelectorAll('[data-category-group]')
      const emptyMsg = panel.querySelector('[data-empty-message]')
      let visibleCount = 0

      items.forEach(item => {
        const rate = item.dataset.rate
        const isOk = rate === 'ok' || rate === 'half'
        const isNg = rate === 'ng'
        const visible = (showOk && isOk) || (showNg && isNg)

        if (visible) {
          item.classList.remove(hiddenClass)
          visibleCount++
        } else {
          item.classList.add(hiddenClass)
        }
      })

      groups.forEach(group => {
        const groupItems = group.querySelectorAll('[data-rate]')
        const hasVisible = Array.from(groupItems).some(item => !item.classList.contains(hiddenClass))
        if (hasVisible) {
          group.classList.remove(hiddenClass)
        } else {
          group.classList.add(hiddenClass)
        }
      })

      if (emptyMsg) {
        if (visibleCount === 0) {
          emptyMsg.classList.remove(hiddenClass)
          this.updateEmptyMessage(emptyMsg, panel.dataset.tabType, showOk, showNg)
        } else {
          emptyMsg.classList.add(hiddenClass)
        }
      }
    })
  }

  updateEmptyMessage (el, tabType, showOk, showNg) {
    if (!showOk && !showNg) {
      el.textContent = '「相談可」「不可」をチェックしてください'
    } else if (showNg && !showOk) {
      el.textContent = tabType === 'disease'
        ? '受け入れ不可の疾患・病気はありません'
        : '受け入れ不可の医療ケアはありません'
    } else {
      el.textContent = tabType === 'disease'
        ? '受け入れ可能な疾患・病気はありません'
        : '受け入れ可能な医療ケアはありません'
    }
  }
}
